import React from 'react';
import { Box } from '@mui/material';
import { PageLayout } from '../layout/primitives';
import { useBooksStore } from '../store/books';
import { getVisibleBooks } from '../books/utils';
import BooksTrackerPanel from '../components/books/BooksTrackerPanel';
import BooksHistogram from '../components/books/BooksHistogram';
import BooksCalendar from '../components/books/BooksCalendar';

const BooksPage: React.FC = () => {
  const books = useBooksStore((state) => state.books);
  const [showCompleted, setShowCompleted] = React.useState(false);
  const visibleBooks = React.useMemo(() => getVisibleBooks(books, showCompleted), [books, showCompleted]);

  return (
    <PageLayout contentMaxWidth={1800} paddingMode="shell">
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <BooksHistogram books={visibleBooks} />
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: 'minmax(0, 1fr)',
              xl: 'minmax(0, 1.1fr) minmax(0, 0.9fr)',
            },
            gap: 3,
            alignItems: 'start',
          }}
        >
          <BooksTrackerPanel
            title="Books"
            emptyMessage="No reading or paused books yet"
            showCompletedToggle
            showCompleted={showCompleted}
            onShowCompletedChange={setShowCompleted}
            variant="page"
          />
          <BooksCalendar books={visibleBooks} />
        </Box>
      </Box>
    </PageLayout>
  );
};

export default BooksPage;
